import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useLocation } from "wouter";
import { Home } from "lucide-react";

export default function NotFound() {
  const [, setLocation] = useLocation();

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle className="text-4xl text-center">404</CardTitle>
          <CardDescription className="text-center">
            Página não encontrada
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-center text-muted-foreground">
            A página que você está procurando não existe ou foi movida.
          </p>
          <Button
            onClick={() => setLocation("/dashboard")}
            className="w-full"
          >
            <Home className="w-4 h-4 mr-2" />
            Voltar para Home
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
